// import styled from 'styled-components';
// import theme from './theme';

// export const Container = styled.div`
//   width: 100%;
//   padding: 20px;
//   display: flex;
//   flex-direction: column;
//   overflow: auto;


//   & + div {
//     display: flex;
//   }

//   h2 {
//     margin-bottom: 20px;
//     font-size: 36px;
//   }
// `;


// import styled from 'styled-components';

// export const Container = styled.div`
//   width: 100%;
//   padding: 32px;
//   display: flex;
//   flex-direction: column;
//   overflow: auto;

//   background: #f8fafc;
//   min-height: 100vh;

//   & + div {
//     display: flex;
//   }

//   h2 {
//     margin: 0;
//     font-size: 48px;
//     font-weight: 700;
//     color: #1e293b;
//     line-height: 1.1;
//   }

//   .page-subtitle {
//     margin-top: 8px;
//     color: #64748b;
//     font-size: 15px;
//   }

//   .page-header {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     margin-bottom: 24px;
//   }

//   .stats-grid {
//     display: grid;
//     grid-template-columns: repeat(4, 1fr);
//     gap: 16px;
//     margin-bottom: 24px;
//   }

//   .stat-card {
//     background: white;
//     border-radius: 14px;
//     padding: 20px;
//     border: 1px solid #e2e8f0;
//     box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
//   }

//   .stat-title {
//     font-size: 14px;
//     color: #64748b;
//     margin-bottom: 8px;
//   }

//   .stat-value {
//     font-size: 28px;
//     font-weight: 700;
//     color: #0f172a;
//   }

//   .filters-container {
//     background: white;
//     border-radius: 14px;
//     padding: 20px;
//     margin-bottom: 20px;
//     border: 1px solid #e2e8f0;
//   }

//   .table-container {
//     background: white;
//     border-radius: 14px;
//     overflow: hidden;
//     border: 1px solid #e2e8f0;
//   }
// `;

import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;

  padding: 32px;

  display: flex;
  flex-direction: column;

  overflow: auto;

  // background-color: ${props => props.darkMode === true ? '#1a1d24' : 'white'};

  h2 {
    margin: 0;
    font-size: 36px;
    font-weight: 700;
    color: #0f172a;
  }

  .page-subtitle {
    margin-top: 6px;
    color: #64748b;
    font-size: 14px;
  }

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-bottom: 24px;
  }

  .filters-card {
    background: white;

    border-radius: 16px;

    padding: 20px;

    margin-bottom: 24px;

    border: 1px solid #e2e8f0;

    box-shadow: 0 1px 3px rgba(0, 0, 0, .05);
  }

  .table-card {
    background: white;

    border-radius: 16px;

    overflow: hidden;

    border: 1px solid #e2e8f0;

    box-shadow: 0 1px 3px rgba(0, 0, 0, .05);
  }
`;


export const MetricsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
  margin-bottom: 24px;
`;

export const MetricCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 22px;

  display: flex;
  align-items: center;
  gap: 16px;

  border: 1px solid #eef2f7;

  box-shadow:
    0 1px 2px rgba(16, 24, 40, 0.04),
    0 4px 12px rgba(16, 24, 40, 0.04);

  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);

    box-shadow:
      0 8px 24px rgba(16, 24, 40, 0.08);
  }
`;

export const MetricIcon = styled.div`
  width: 52px;
  height: 52px;

  border-radius: 14px;

  display: flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;
`;

export const MetricContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MetricTitle = styled.div`
  font-size: 14px;
  color: #64748b;
  margin-bottom: 4px;
`;

export const MetricValue = styled.div`
  font-size: 34px;
  font-weight: 700;
  line-height: 1;
  color: #0f172a;
`;

export const MetricSubtitle = styled.div`
  margin-top: 4px;

  font-size: 13px;
  color: #94a3b8;
`;

export const FiltersCard = styled.div`
  background: ${props => props.darkMode === true ? '#1a1d24' : 'white'};

  border: 1px solid #eef2f7;

  border-radius: 16px;

  padding: 20px;

  margin-bottom: 24px;

  box-shadow:
    0 1px 2px rgba(16,24,40,0.04),
    0 4px 12px rgba(16,24,40,0.04);
`;

export const FiltersRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
`;

export const SearchWrapper = styled.div`
  display: flex;
  flex: 1;
  min-width: 320px;
  maxWidth: 700px;
  gap: 12px;
`;

export const FilterSelectWrapper = styled.div`
  width: 220px;
`;